<script>
import { layoutComputed } from '@/state/helpers';
import Vertical from './vertical';
import Horizontal from './horizontal';
import PageHeader from '@/components/page-header';

export default {
  props: {
    title: {
      type: String,
      default: 'inventory.inventory',
    },
    noCard: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    window.addEventListener('keyup', ({ key, metaKey }) => {
      if (key == 'Escape') {
        this.$emit('esc-pressed');

        let diff = Date.now() - this.lastEscTime;

        this.lastEscTime = Date.now();

        if (diff < 220) {
          this.$emit('esc-double-pressed');
          this.lastEscTime = 0;
        }
      } else if (key == 'Enter') {
        if (metaKey) {
          this.$emit('ctrl-enter-pressed');
        }
      }
    });
  },
  components: {
    Vertical,
    Horizontal,
    PageHeader,
  },
  data() {
    return {
      lastEscTime: 0,
    };
  },
  computed: {
    ...layoutComputed,
  },
};
</script>

<template>
  <div>
    <vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <PageHeader :title="title" />
      <slot v-if="noCard" />
      <b-card v-else>
        <slot />
      </b-card>
    </vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
      <slot />
    </Horizontal>
  </div>
</template>
